import { Button } from '../ui/button';
import { useNavigate, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { cn } from '@/lib/utils';

const NAVIGATION_ITEMS = [
  { label: 'User Management', path: '/settings/user-management', disabled: false },
  { label: 'Notifications', path: '/settings/notifications', disabled: true },
  { label: 'Environment', path: '/settings/environment', disabled: false },
];

const AUTOPILOT_ITEMS = [
  { label: 'Automations', path: '/settings/automations', disabled: false },
  { label: 'Profiles', path: '/settings/profiles', disabled: false },
  { label: 'Calendar', path: '/settings/calendar', disabled: false },
  { label: 'Blueprints', path: '/settings/blueprints', disabled: false },
];

export function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;
  
  // Get app mode from environment variables
  const appMode = import.meta.env.VITE_APP_MODE || 'normal';

  useEffect(() => {
    if (currentPath === '/settings' || currentPath === '/settings/') {
      // In multi mode, only consider NAVIGATION_ITEMS for auto-redirect
      const availableItems = appMode === 'multi' ? NAVIGATION_ITEMS : [...NAVIGATION_ITEMS, ...AUTOPILOT_ITEMS];
      const firstEnabledItem = availableItems.find(item => !item.disabled);
      if (firstEnabledItem) {
        navigate(firstEnabledItem.path);
      }
    }
  }, [currentPath, navigate, appMode]);

  return (
    <div className="flex flex-col">
      <div className="w-[326px] h-fit flex flex-col gap-6 p-4 bg-white rounded-xl shadow-sm border border-light-grey transition-all duration-200 hover:shadow-md">
        <div className="flex flex-col gap-3">
          <div className="flex flex-col gap-2">
            <h3 className="heading-7 text-dark-blue px-2">General Settings</h3>
            <div className="flex flex-col gap-1">
              {NAVIGATION_ITEMS.map((item) => (
                <Button
                  key={item.path}
                  disabled={item.disabled}
                  variant={currentPath === item.path ? "text" : "textDisabled"}
                  size="md"
                  className={cn(
                    "w-full transition-all duration-200",
                    currentPath === item.path
                      ? "bg-white-blue text-dark-blue font-medium"
                      : item.disabled
                        ? "text-[#B4B4B4] hover:bg-transparent cursor-not-allowed opacity-40"
                        : "text-dark-grey hover:bg-light-grey/50 hover:text-dark-blue",
                  )}
                  onClick={() => navigate(item.path)}
                >
                  <span className="w-full text-left button-s">{item.label}</span>
                </Button>
              ))}
            </div>
          </div>

          {/* Only show Autopilot Settings in normal mode */}
          {appMode !== 'multi' && (
            <>
              <div className="border-t border-light-grey" />

              <div className="flex flex-col gap-2">
                <h3 className="heading-7 text-dark-blue px-2">Autopilot Settings</h3>
                <div className="flex flex-col gap-1">
                  {AUTOPILOT_ITEMS.map((item) => (
                    <Button
                      key={item.path}
                      disabled={item.disabled}
                      variant={currentPath === item.path ? "text" : "textDisabled"}
                      size="md"
                      className={cn(
                        "w-full transition-all duration-200",
                        currentPath === item.path
                          ? "bg-white-blue text-dark-blue font-medium"
                          : item.disabled
                            ? "text-[#B4B4B4] hover:bg-transparent cursor-not-allowed opacity-40"
                            : "text-dark-grey hover:bg-light-grey/50 hover:text-dark-blue",
                      )}
                      onClick={() => navigate(item.path)}
                    >
                      <span className="w-full text-left button-s">{item.label}</span>
                    </Button>
                  ))}
                </div>
              </div>
            </>
          )}
        </div>
      </div>
      <div className="mt-3 w-[326px] h-fit flex flex-col p-4 bg-white rounded-xl shadow-sm border border-light-grey transition-all duration-200 hover:shadow-md">
        <div className="flex flex-col gap-1.5">
          <div className="flex justify-between items-center">
            <span className="text-[11px] text-gray-500">Version</span>
            <span className="text-[11px] text-gray-700">v1-2025.1.0</span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-[11px] text-gray-500">Emergency contact</span>
            <span className="text-[11px] text-primary hover:text-primary/80 transition-colors">+66 0868486464</span>
          </div>
        </div>
      </div>
    </div>
  );
}